import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

function AssistantDeploiementPage({ assistant }) {
  const [ongletActif, setOngletActif] = useState(0);
  const [rafraichirDeclencheur, setRafraichirDeclencheur] = useState(0);
  const Formulaire = assistant.composants.Formulaire;
  const Historique = assistant.composants.Historique;
  const historiqueDisponible = Historique && Historique !== Formulaire;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Button component={Link} to="/Ingenierie/Deploiements" variant="outlined" style={{ marginBottom: 12 }}>
          Retour aux assistants
        </Button>
        <Paper className="rounded-lg bg-primary" style={{ padding: 16 }}>
          <Typography className="text-primary" variant="h4">
            Ingenierie - {assistant.titre}
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            {assistant.resume}
          </Typography>
          <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: 'block' }}>
            Etapes: {assistant.etapes.join(' - ')}
          </Typography>
          <Tabs
            value={ongletActif}
            onChange={(event, valeur) => setOngletActif(valeur)}
            indicatorColor="primary"
            textColor="primary"
            style={{ marginTop: 16 }}
          >
            <Tab label={assistant.libelleNouveau || 'Nouveau deploiement'} />
            <Tab label={assistant.libelleHistorique || 'Historique rapports'} disabled={!historiqueDisponible} />
          </Tabs>
        </Paper>
      </Grid>

      {ongletActif === 0 && Formulaire && (
        <Grid item xs={12}>
          <Formulaire onCreation={() => {
            setRafraichirDeclencheur((precedent) => precedent + 1);
            if (historiqueDisponible) {
              setOngletActif(1);
            }
          }} assistant={assistant} />
        </Grid>
      )}

      {ongletActif === 1 && historiqueDisponible && (
        <Grid item xs={12}>
          <Historique rafraichirDeclencheur={rafraichirDeclencheur} assistant={assistant} />
        </Grid>
      )}
    </Grid>
  );
}

export default AssistantDeploiementPage;



// WEBPACK FOOTER //
// src/components/deploiements/AssistantDeploiementPage.js